import React from 'react';
import FocusLock from 'react-focus-lock';
import CloseIcon from './CloseIcon';

const BaseModalV2 = ({ onClose, children, title }) => {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <FocusLock returnFocus className="w-full flex justify-center">
        <div className="relative bg-white rounded-lg shadow-lg p-3 max-w-[565px] w-full px-[35px] sm:px-[63px] py-[30px] sm:py-[59px] max-h-[98vh] overflow-y-auto">
          <button
            className="absolute p-[16px] top-[35px] sm:top-[63px] right-[30px] sm:right-[59px] text-gray-500 bg-[#F2F4F8] rounded-full w-[45px] h-[45px]"
            onClick={onClose}
            aria-label="Close dialog"
          >
            <CloseIcon size="15px" />
          </button>
          <h2 id="modal-title" className="text-black mb-4 text-[26px] sm:text-[32px] font-bold">
            {title}
          </h2>
          {children}
        </div>
      </FocusLock>
    </div>
  );
};

export default BaseModalV2;
